<template>
  <div>

    <b-button size="sm" class="mb-2" @click="showAdd=true">
      <b-icon-cart-plus></b-icon-cart-plus>
      Добавить
    </b-button>

    <multi-select
      v-if="showAdd"
      v-model="dealSelectedToAdd"
      v-on:input="onSelect"
      :options="options"
      :searchable="true"
      :loading="isLoading"
      :internal-search="false"
      :hide-selected="true"
      track-by="title"
      label="title"
      placeholder="Введите название для поиска"
      selectLabel="Enter чтобы выбрать"
      @search-change="asyncFind"
    >
      <template slot="noOptions">Начните вводить имя</template>
      <span slot="noResult">Не найдено</span>
    </multi-select>
    <div>
      <b-form-row class="mb-1 mt-1">
        <b-col>
        </b-col>
        <b-col cols="3">
          <div class="text-right"><strong>{{ totalDeals }}</strong></div>
        </b-col>
        <b-col cols="1">
        </b-col>
      </b-form-row>
    </div>
    <div v-for="deal in deals" v-bind:key="deal.id">
      <deal-list-entry :deal="deal" v-on:removeItem="removeDeal"></deal-list-entry>
    </div>
  </div>
</template>

<script>
import DealListEntry from "./DealListEntry";
import MultiSelect from 'vue-multiselect'

export default {
  name: "deals",
  components: {DealListEntry, MultiSelect},
  props: {
    value: Array
  },
  data() {
    return {
      dealSelectedToAdd: [],
      options: [],
      isLoading: false,
      deals: [],
      showAdd: false
    }
  },
  watch: {
    'value': {
      handler: function (data) {
        if (data) {
          this.deals = data;
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    totalDeals() {
      let total = 0.0;
      for (let deal of this.deals) {
        total += parseFloat(deal.amount);
      }
      return Intl.NumberFormat('ru-RU', {style: 'currency', currency: 'RUB'}).format(total)
    }
  },
  mounted() {

  },
  methods: {
    removeDeal(dealId) {
      this.deals = this.deals.filter(function (value) {
        return value.id !== dealId;
      });
      this.$emit('input', this.deals);
    },
    asyncFind(query) {
      this.isLoading = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/deals?query=' + query);
      return promise.then(response => {
        this.options = response.data.deals;
        this.deals.forEach(e => {
          this.options = this.options.filter(function (value) {
            return value.id !== e.id
          });
        });

        this.isLoading = false;
      }).catch((error) => {
        console.log(error);
        this.options = [];
        this.isLoading = false;
      });
    },
    onSelect(evt) {
      this.deals = this.deals.filter(function (value) {
        return value.id !== evt.id;
      });
      this.deals.push(evt)
      this.$emit('input', this.deals);
      this.dealSelectedToAdd = [];
      this.showAdd = false;
    }
  }
}
</script>
<style lang="scss">
.alert {
  padding: 0.4rem 1rem;

  button {
    padding: 0.4rem 1rem !important;
  }
}
</style>
